import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue';
import VueCookies from 'vue-cookies'
import store from './store'
Vue.use(VueCookies)
Vue.prototype.$cookies = VueCookies

import delPop from './views/components/delPop.vue'

Vue.component('delPop',delPop)

Vue.use(ElementUI);

import XLSX from 'xlsx'
Vue.prototype.XLSX = XLSX

import router from '@/router'

Vue.config.productionTip = false

new Vue({
	router,
	store,
  render: h => h(App),
}).$mount('#app')
